import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import ChatInput from '@/components/AskMeAnything/components/ChatInput';
import ChatResponse from '@/components/AskMeAnything/components/ChatResponse';
import useChatLogic from '@/components/AskMeAnything/hooks/useChatLogic';
import Suggestions from '@/components/suggestions/Suggestions';
import { SuggestionsProvider } from '@/components/suggestions/context/SuggestionsProvider';
import { QUICK_ACTIONS_ROUTE } from '@/enums/RoutesMap';
import { useChatActions, useActiveThreadId } from '@/store/chat/chatStore';
import { useIsSmallScreen } from '@/utils/mediaUtil';

import {
  ChatInputContainer,
  ChatPageContainer,
  ChatResponseContainer,
  MOBILE_PADDING,
  PADDING,
  SuggestionsContainer
} from './ChatPageStyles';

const ChatPage = () => {
  const { handleSubmit, setChatTitle, activeThread } = useChatLogic();
  const { threadId } = useParams();
  const { setActiveThreadId, setIsThreadNew } = useChatActions();
  const activeThreadId = useActiveThreadId();
  const isSmallScreen = useIsSmallScreen();

  const isQuickActionsOpen = threadId === QUICK_ACTIONS_ROUTE;

  useEffect(() => {
    if (threadId && threadId !== activeThreadId && !isQuickActionsOpen) {
      setActiveThreadId(threadId);
      setIsThreadNew(false);
    }
  }, [threadId, activeThreadId, setActiveThreadId, setIsThreadNew, isQuickActionsOpen]);

  return (
    <ChatPageContainer>
      <ChatResponseContainer>
        {activeThreadId ? (
          <ChatResponse
            setChatTitle={setChatTitle}
            activeThread={activeThread}
            style={{ padding: isSmallScreen ? MOBILE_PADDING : PADDING }}
          />
        ) : (
          <div
            style={{
              height: '100%',
              width: '100%',
              padding: isSmallScreen ? MOBILE_PADDING : PADDING
            }}
          ></div>
        )}
      </ChatResponseContainer>
      {isQuickActionsOpen && (
        <SuggestionsContainer>
          <SuggestionsProvider>
            <Suggestions />
          </SuggestionsProvider>
        </SuggestionsContainer>
      )}
      {!isQuickActionsOpen && (
        <ChatInputContainer style={{ padding: isSmallScreen ? 0 : PADDING }}>
          <ChatInput onSubmit={handleSubmit} />
        </ChatInputContainer>
      )}
    </ChatPageContainer>
  );
};

export default ChatPage;
